import { render, staticRenderFns } from "./doctorFollowList.vue?vue&type=template&id=315b21de&scoped=true&"
import script from "./doctorFollowList.vue?vue&type=script&lang=js&"
export * from "./doctorFollowList.vue?vue&type=script&lang=js&"
import style0 from "./doctorFollowList.vue?vue&type=style&index=0&id=315b21de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315b21de",
  null
  
)

export default component.exports